import { useQuery } from "@tanstack/react-query"
import { useEffect } from "react"
import { GetDescuadreSaldosAsientosContablesDtoProps } from "./DTOs/GetDescuadreSaldosAsientosContablesDto"
import {
  getLineaAsientoContableDescuadreSaldos,
  postLineaAsientoContableRecalcularSaldos,
} from "./LineaAsientoContable.service"

const compararArrays = (
  array1: GetDescuadreSaldosAsientosContablesDtoProps[],
  array2: GetDescuadreSaldosAsientosContablesDtoProps[]
) => {
  if (array1.length !== array2.length) return false

  const ordenarPorCuentaContableId = (
    a: GetDescuadreSaldosAsientosContablesDtoProps,
    b: GetDescuadreSaldosAsientosContablesDtoProps
  ) => a.cuentaContableId.localeCompare(b.cuentaContableId)
  const array1Ordenado = array1.sort(ordenarPorCuentaContableId)
  const array2Ordenado = array2.sort(ordenarPorCuentaContableId)

  return array1Ordenado.every((obj1, index) =>
    Object.entries(obj1).every(
      ([key, value]) =>
        value ===
        array2Ordenado[index][
          key as keyof GetDescuadreSaldosAsientosContablesDtoProps
        ]
    )
  )
}
export function useLineaAsientoDescuadre() {
  const { data } = useQuery({
    queryKey: ["getDescuadreSaldosAsientosContables"],
    queryFn: () => getLineaAsientoContableDescuadreSaldos(),
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: false,
  })

  useEffect(() => {
    if (!data) return

    const STORAGE_KEY = "descuadreSaldosAsientosContablesArray"
    const sessionValue = sessionStorage.getItem(STORAGE_KEY)

    const sessionArray: GetDescuadreSaldosAsientosContablesDtoProps[] =
      sessionValue ? JSON.parse(sessionValue) : []

    const isFirstCall = !sessionValue
    const isDataEmpty = data.length === 0
    const updateSessionStorage = (newData: typeof data) => {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(newData))
    }

    const recalculate = (
      newData: GetDescuadreSaldosAsientosContablesDtoProps[]
    ) => {
      updateSessionStorage(newData)
      postLineaAsientoContableRecalcularSaldos(newData)
    }

    if (isFirstCall) {
      if (isDataEmpty) {
        updateSessionStorage([])
      } else {
        recalculate(data)
      }
      return
    }
    const isDataSame = compararArrays(sessionArray, data)
    if (isDataSame) {
      return
    }
    recalculate(data)
  }, [data])
}
